import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopinDialogComponent } from './popin-dialog/popin-dialog.component';
import {RouterModule} from '@angular/router';
import { PopinDialogHeaderComponent } from './popin-dialog-header/popin-dialog-header.component';
import {PopinOutletComponent} from './popin-outlet/popin-outlet.component';
import { PopinNavbarRightComponent } from './popin-navbar-right/popin-navbar-right.component';
import { PopinAnchorDirective } from './popin-anchor.directive';
import { SimplePopinComponent } from './simple-popin/simple-popin.component';



@NgModule({
  declarations: [PopinDialogComponent, PopinDialogHeaderComponent, PopinOutletComponent, PopinNavbarRightComponent, PopinAnchorDirective, SimplePopinComponent],
    imports: [
        CommonModule,
        RouterModule
    ],
  exports: [
    PopinDialogComponent,
    PopinOutletComponent,
    PopinNavbarRightComponent,
    PopinAnchorDirective,
    SimplePopinComponent
  ]
})
export class PopinDialogModule { }
